// 选片功能链接与同意状态工具（独立于 delivery）。
// 选片仅使用短链（详情落库 D1），不支持 base64 自包含链接。
import { parseSelectionConsentClauseIds } from "./deliveryConsent";

export function isExpired(expiryUtcSeconds) {
    return Date.now() >= expiryUtcSeconds * 1000;
}

export function buildSelectionUrl(token) {
    const { origin, pathname } = window.location;
    const base = pathname.endsWith("/") ? pathname.slice(0, -1) : pathname;
    return `${origin}${base}/#/s/${token}`;
}

export function getAlbumName(payload, fallback) {
    if (payload?.n) {
        return payload.n;
    }
    return fallback || "";
}

export function getConsentVariant(payload) {
    return payload?.c === "s" ? "sponsor" : "general";
}

export function getConsentClauseIds(payload) {
    return parseSelectionConsentClauseIds(payload?.c);
}

// 知情同意状态：与 delivery 一样存 sessionStorage，但用独立 key 前缀。
export function getConsentKey(token) {
    return `selection-consent:${token}`;
}

export function hasConsent(token) {
    try {
        return sessionStorage.getItem(getConsentKey(token)) === "1";
    } catch {
        return false;
    }
}

export function setConsent(token) {
    try {
        sessionStorage.setItem(getConsentKey(token), "1");
    } catch {
        // sessionStorage unavailable
    }
}
